define('app/services.js',[], function() { 
    
    var services = {};

    services.dataService = function($http, $q) {

		var language = 'english';
		this.getLanguage = function() {
			return language;
		};

        var cities = [
            {
                "name": "Berlin",
                "map": "maps/berlin.jpg",
                "layout": "mapRight",
                "description": {"english": "BERLIN is the capital of Germany and one of its 16 states. With a population of approximately 3.5 million people, Berlin is the second most populous city proper and the seventh most populous urban area in the European Union. Around one-third of the city's area is composed of forests, parks, gardens, rivers and lakes."}
            },
            {
                "name": "Amsterdam",
                "map": "maps/amsterdam.jpg",
                "layout": "mapLeft",
                "description": {"english": "AMSTERDAM is the capital and most populous municipality of the Kingdom of the Netherlands. Amsterdam has a population of 839,360 within the city proper, 1,336,383 in the urban area, and 2,431,000 in the Amsterdam metropolitan area. The city is located in the province of North Holland in the west of the country, and is also North Holland's largest city."}
            },
            {
                "name": "Paris",
                "map": "maps/paris.jpg",
                "layout": "mapLeft",
                "description": {"english": "PARIS is the capital and most populous city of France. Situated on the river Seine in the north of the country, it is in the centre of the Île-de-France region, also known as the région parisienne, \"Paris Region\". Paris' metropolitan area spans most of the Île-de-France region and has a population of 12,405,426 (Jan. 2013 census), constituting one-fifth of the population of France."}
            },
            {
                "name": "Madrid",
                "map": "maps/madrid.jpg",
                "layout": "mapLeft",
                "description": {"english": "MADRID is the capital of Spain, and the largest municipality of the Community of Madrid. The population of the city is almost 3.2 million with a metropolitan area population of approximately 6.5 million. It is the third-largest city in the European Union, after London and Berlin, and its metropolitan area is the third-largest in the European Union after London and Paris."}
            },
            {
                "name": "Vienna",
                "map": "maps/vienna.jpg",
                "layout": "mapRight",
                "description": {"english": "VIENNA is the capital and largest city of Austria, and one of the nine states of Austria. Vienna is Austria's primary city, with a population of about 1.8 million (2.6 million within the metropolitan area, nearly one third of Austria's population), and its cultural, economic, and political centre. It is the 7th-largest city by population within city limits in the European Union. It has the second largest number of German speakers after Berlin. Vienna is host to many major international organizations, including the United Nations and OPEC. In 2001, the city centre was designated a UNESCO World Heritage Site."}
            },
            {
                "name": "Warsaw",
                "map": "maps/warsaw.jpg",
                "layout": "mapRight",
                "description": {"english": "WARSAW is the capital and largest city of Poland. It stands on the Vistula River in east-central Poland, roughly 260 kilometres (160 mi) from the Baltic Sea and 300 kilometres (190 mi) from the Carpathian Mountains. Its population is estimated at 1.740 million residents within a greater metropolitan area of 2.666 million residents, which makes Warsaw the 9th most-populous capital city in the European Union."}
            },
            {
                "name": "Stockholm",
                "map": "maps/stockholm.jpg",
                "layout": "mapLeft",
                "description": {"english": "STOCKHOLM is the capital of Sweden and the most populous city in the Nordic countries, with 909,976 people living in the municipality, approximately 1.4 million in the urban area, and 2.2 million in the metropolitan area. The city is spread across 14 islands on the coast in the southeast of Sweden at the mouth of Lake Mälaren, by the Stockholm archipelago and the Baltic Sea. The area has been settled since the Stone Age, in the 6th millennium BC, and was founded as a city in 1252 by a Swedish statesman Birger Jarl."}
            },
            {
                "name": "London",
                "map": "maps/london.jpg",
                "layout": "mapLeft",
                "description": {"english": "LONDON is the capital and most populous city of England, Great Britain, and the United Kingdom. Standing on the River Thames in the south eastern part of the island of Great Britain, London has been a major settlement for two millennia. It was founded by the Romans, who named it Londinium. London is a leading global city, with strengths in the arts, commerce, education, entertainment, fashion, finance, healthcare, media, professional services, research and development, tourism, and transport all contributing to its prominence."}
            },
            {
                "name": "Brussels",
                "map": "maps/brussels.jpg",
                "layout": "mapLeft",
                "description": {"english": "BRUSSELS is the largest municipality of the Brussels-Capital Region, and the de jure capital of Belgium. The City of Brussels is a municipality consisting of the central historic town and certain additional areas within the greater Brussels-Capital Region. On 1 January 2015, the City of Brussels had a total population of 175,534. The total area is 32.61 km2 (12.59 sq mi) which gives a population density of 5,464 inhabitants per square kilometre (14,150/sq mi)."}
            },
            {
                "name": "Prague",
                "map": "maps/prague.jpg",
                "layout": "mapRight",
                "description": {"english": "PRAGUE is the capital and largest city of the Czech Republic. It is the 14th largest city in the European Union. It is also the historical capital of Bohemia. Situated in the north-west of the country on the Vltava River, the city is home to about 1.26 million people, while its larger urban zone is estimated to have a population of nearly 2 million. The city has a temperate climate, with warm summers and chilly winters. Prague has the lowest unemployment rate in the European Union."}
            },
            {
                "name": "Copenhagen",
                "map": "maps/copenhagen.jpg",
                "layout": "mapLeft",
                "description": {"english": "COPENHAGEN is the capital and most populated city of Denmark. It has a municipal population of 591,481 and a larger urban population of 1,280,371 (as of 1 January 2016). The Copenhagen metropolitan area has just over 2 million inhabitants. Originally a Viking fishing village founded in the 10th century, Copenhagen became the capital of Denmark in the early 15th century."}
            },
            {
                "name": "Tallinn",
                "map": "maps/tallinn.jpg",
                "layout": "mapRight",
                "description": {"english": "TALLINN is the capital and largest city of Estonia. It is situated on the northern coast of the country, on the shore of the Gulf of Finland. Tallinn occupies an area of 159.2 km2 (61.5 sq mi) and has a population of 440,597. Approximately 32% of Estonia's total population lives in Tallinn. Founded in 1248 but the earliest human settlements date back to 3000 years BC, making it one of the oldest capital cities of Northern Europe."}
            },
            {
                "name": "Helsinki",
                "map": "maps/helsinki.jpg",
                "layout": "mapRight",
                "description": {"english": "HELSINKI is the capital and largest city of Finland. Helsinki has a population of 629,512, an urban population of 1,214,210, and a metropolitan population of over 1.4 million, making it the most populous municipality and urban area in Finland. In 2011, the Monocle magazine ranked Helsinki the most liveable city in the world in its \"Liveable Cities Index 2011.\" In the Economist Intelligence Unit's August 2015 Liveability survey, assessing the best and worst cities to live in globally, Helsinki placed among the world's top ten cities."}
            },
            {
                "name": "Athens",
                "map": "maps/athens.jpg",
                "layout": "mapRight",
                "description": {"english": "ATHENS is the capital and largest city of Greece. Athens dominates the Attica region and is one of the world's oldest cities, with its recorded history spanning around 3,400 years, and the earliest human presence started somewhere between the 11th and 7th millennia BC. Classical Athens was a powerful city-state. A centre for the arts, learning and philosophy, home of Plato's Academy and Aristotle's Lyceum, it is widely referred to as the cradle of Western civilization and the birthplace of democracy, largely because of its cultural and political impact on the European continent and in particular the Romans."}
            },
            {
                "name": "Budapest",
                "map": "maps/budapest.jpg",
                "layout": "mapRight",
                "description": {"english": "BUDAPEST is the capital and the largest city of Hungary, and one of the largest cities in the European Union. It is the country's principal political, cultural, commercial, industrial, and transportation centre, sometimes described as the primate city of Hungary. According to the census, in 2011 Budapest had 1.74 million inhabitants, down from its 1989 peak of 2.1 million due to suburbanisation. Budapest became a single city occupying both banks of the river Danube with the unification of Buda and Óbuda on the west bank, with Pest on the east bank on 17 November 1873."}
            },
            {
                "name": "Dublin",
                "map": "maps/dublin.jpg",
                "layout": "mapLeft",
                "description": {"english": "DUBLIN is the capital and largest city of Ireland. Dublin is in the province of Leinster on Ireland's east coast, at the mouth of the River Liffey. The city has an urban area population of 1,273,069. The population of the Greater Dublin Area, as of 2011, was 1,801,040 persons. Founded as a Viking settlement, the Kingdom of Dublin became Ireland's principal city following the Norman invasion."}
            },
            {
                "name": "Rome",
                "map": "maps/rome.jpg",
                "layout": "mapRight",
                "description": {"english": "ROME is a city and special comune (named Roma Capitale) in Italy. Rome is the capital of Italy and of the Lazio region. With 2.9 million residents in 1,285 km2 (496.1 sq mi), it is also the country's largest and most populated comune and fourth-most populous city in the European Union by population within city limits. Rome's history spans more than two and a half thousand years. While Roman mythology dates the founding of Rome at only around 753 BC, the site has been inhabited for much longer, making it one of the oldest continuously occupied sites in Europe. The Vatican City is an independent country geographically located within the city boundaries of Rome, the only existing example of a country within a city: for this reason Rome has been often defined as capital of two states."}
            },
            {
                "name": "Oslo",
                "map": "maps/oslo.jpg",
                "layout": "mapLeft",
                "description": {"english": "OSLO is the capital and the most populous city in Norway. Founded in the year 1040, and established as a \"kaupstad\" or trading place in 1048 by King Harald III, the city was elevated to a bishopric in 1070 and a capital under Haakon V around 1300. Oslo is the economic and governmental centre of Norway. The city is also a hub of Norwegian trade, banking, industry and shipping. It is an important centre for maritime industries and maritime trade in Europe."}
            },
            {
                "name": "Lisbon",
                "map": "maps/lisbon.jpg",
                "layout": "mapLeft",
                "description": {"english": "LISBON is the capital and the largest city of Portugal, with a population of 552,700 within its administrative limits in an area of 100.05 km². Its urban area extends beyond the city's administrative limits with a population of around 2.7 million people, being the 11th-most populous urban area in the European Union. About 2.8 million people live in the Lisbon Metropolitan Area (which represents approximately 27% of the country's population). It is continental Europe's westernmost capital city and the only one along the Atlantic coast. The westernmost areas of its metro area is the westernmost point of Continental Europe."}
            },
            {
                "name": "Bratislava",
                "map": "maps/bratislava.jpg",
                "layout": "mapRight",
                "description": {"english": "BRATISLAVA is the capital of Slovakia, and with a population of about 450,000, the country's largest city. Bratislava is in southwestern Slovakia, occupying both banks of the River Danube and the left bank of the River Morava. Bordering Austria and Hungary, it is the only national capital that borders two independent countries."}
            },
            {
                "name": "Ljubljana",
                "map": "maps/ljubljana.jpg",
                "layout": "mapRight",
                "description": {"english": "LJUBLJANA is the capital and largest city of Slovenia. During antiquity, it was the site of a Roman city called Emona. Situated at the middle of a trade route between the northern Adriatic Sea and the Danube region and it has been the cultural, educational, economic, political, and administrative center of independent Slovenia since 1991."}
            },
            {
                "name": "Geneva",
                "map": "maps/geneva.jpg",
                "layout": "mapLeft",
                "description": {"english": "GENEVA is the second most populous city in Switzerland (after Zürich) and is the most populous city of Romandy, the French-speaking part of Switzerland. Situated where the Rhône exits Lake Geneva, it is the capital of the Republic and Canton of Geneva. Geneva is a global city, a financial center, and worldwide center for diplomacy due to the presence of numerous international organizations, including the headquarters of many of the agencies of the United Nations and the Red Cross. Geneva is the city that hosts the highest number of international organizations in the world."}
            },
            {
                "name": "Vilnius",
                "map": "maps/vilnius.jpg",
                "layout": "mapRight",
                "description": {"english": "VILNIUS is the capital of Lithuania and its largest city, with a population of 542,664 as of 2015. Vilnius is located in the southeast part of Lithuania and is the second largest city in the Baltic states. Vilnius is known for the architecture in its Old Town, declared a UNESCO World Heritage Site in 1994. Its Jewish influence until the 20th century has led to it being described as the \"Jerusalem of Lithuania\" and Napoleon named it \"the Jerusalem of the North\" as he was passing through in 1812."}
            },
            {
                "name": "Riga",
                "map": "maps/riga.jpg",
                "layout": "mapRight",
                "description": {"english": "RIGA is the capital and the largest city of Latvia. With 641,007 inhabitants (2015), Riga is the largest city of the Baltic states and home to one third of Latvia's population. Riga was founded in 1201 and is a former Hanseatic League member. Riga's historical centre is a UNESCO World Heritage Site, noted for its Art Nouveau/Jugendstil architecture and 19th century wooden architecture."}
            },
            {
                "name": "Sofia",
                "map": "maps/sofia.jpg",
                "layout": "mapRight",
                "description": {"english": "SOFIA is the capital and largest city of Bulgaria. The city has a population of 1.26 million, while over 1.5 million people live in its functional urban area. Sofia has been an area of human habitation since at least 7000 BCE. Being Bulgaria's primate city, Sofia is a hometown of many of the major local universities, cultural institutions and commercial companies. Sofia is one of the top 10 best places for start-up business in the world, especially in IT technologies. Sofia is Europe's most affordable capital to visit as of 2013."}
            },
            {
                "name": "Luxembourg",
                "map": "maps/luxemborg.jpg",
                "layout": "mapLeft",
                "description": {"english": "LUXEMBOURG is the capital city of the Grand Duchy of Luxembourg (also named \"Luxembourg\"), and the country's most populous commune. The city contains Luxembourg Castle, established by the Franks in the Early Middle Ages, around which a settlement developed. As of January 2016, the commune had a population of 115,227, which was more than three times the population of the country's second most populous commune (Esch-sur-Alzette)."}
            },
            {
                "name": "Zurich",
                "map": "maps/zurich.jpg",
                "layout": "mapLeft",
                "description": {"english": "ZURICH is the largest city in Switzerland and the capital of the canton of Zürich. It is located in north-central Switzerland at the northwestern tip of Lake Zürich. The municipality has approximately 400,028 inhabitants. Zürich is a hub for railways, roads, and air traffic. Permanently settled for around 2000 years, Zürich has a history that goes back to its founding by the Romans, who, in 15 BC, called it Turicum. However, early settlements have been found dating back more than 6400 years ago."}
            },
            {
                "name": "Milan",
                "map": "maps/milan.jpg",
                "layout": "mapLeft",
                "description": {"english": "MILAN is the capital of Lombardy, the most rich and populated region in Italy. Located in southern Europe, the city spans a total of 181.8 square kilometres (70.2 square miles): the population of the city proper is 1.3 million, the 2nd-largest populated Italian municipality after Rome. Milan is part of the so-called Blue Banana: in terms of GDP, the city has the 3rd-largest economy among EU cities after London and Paris, and the largest among European non-capital cities. Milan is a leading global city, with strengths in the arts, commerce, design, education, entertainment, fashion, finance, healthcare, media, services, research, tourism."}
            },
            {
                "name": "Frankfurt",
                "map": "maps/frankfurt.jpg",
                "layout": "mapLeft",
                "description": {"english": "FRANKFURT is the fifth-largest city in Germany, with a 2015 population of 731,095 within its administrative boundaries. The urban area called Frankfurt Rhein-Main has a population of 2,221,910. Frankfurt is a global hub for commerce, culture, education, tourism and traffic. It is the most important financial centre of the European continent, with the HQs of the European Central Bank, German Federal Bank, Frankfurt Stock Exchange, Deutsche Bank, Commerzbank, DZ Bank, KfW, several fintech startups and other institutes. Messe Frankfurt is one of the world's largest trade fairs. Major fairs include the Frankfurt Motor Show, the world's largest motor show, and the Frankfurt Book Fair, the world's largest book fair."}
            },
            {
                "name": "Barcelona",
                "map": "maps/barcelona.jpg",
                "layout": "mapLeft",
                "description": {"english": "BARCELONA is the capital city of the autonomous community of Catalonia in the Kingdom of Spain as well as the country's second most populous municipality, with a population of 1.6 million within city limits. It is the largest metropolis on the Mediterranean Sea. Founded as a Roman city, besieged several times during its history, Barcelona has a rich cultural heritage and is today an important cultural center and a major tourist destination. Particularly renowned are the architectural works of Antoni Gaudí and Lluís Domènech i Montaner, which have been designated UNESCO World Heritage Sites."}
            },
            {
                "name": "Glasgow",
                "map": "maps/glasgow.jpg",
                "layout": "mapLeft",
                "description": {"english": "GLASGOW is the largest city in Scotland, and the third largest in the United Kingdom (after London and Birmingham). Glasgow grew from a small rural settlement on the River Clyde to become the largest seaport in Britain. Expanding from the medieval bishopric and royal burgh, and the later establishment of the University of Glasgow in the 15th century, it became a major centre of the Scottish Enlightenment in the 18th century. From the 18th century the city also grew as one of Great Britain's main hubs of transatlantic trade with North America and the West Indies."}
            },
            {
                "name": "Bucharest",
                "map": "maps/bucharest.jpg",
                "layout": "mapRight",
                "description": {"english": "BUCHAREST is the capital and largest city of Romania, as well as its cultural, industrial, and financial centre. Bucharest was first mentioned in documents in 1459. It became the capital of Romania in 1862 and is the centre of Romanian media, culture, and art. Its architecture is a mix of historical (neo-classical), interbellum (Bauhaus and art deco), communist-era and modern. In the period between the two World Wars, the city's elegant architecture and the sophistication of its elite earned Bucharest the nickname of \"Little Paris\" (Micul Paris). According to the 2011 census, 1,883,425 inhabitants live within the city limits."}
            }
        ]

        this.getCities = function() {
            return cities;
        };

        // var options = [];
        // $http.get('app/options.json').success(function(data) {
        //     options = data.options;
        // });

		var options = [
            {
                "name": "museums",
                "active": false,
                "thumbnail": "icons/icon-museums.jpg",
                "label": {"english": "Museums"},
                "field": "Museums",
                "valueTextTemplate": {"english": "There are {{value}} museums in {{city}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }, {
                "name": "gdp",
                "active": false,
                "thumbnail": "icons/icon-gdp.jpg",
                "label": {"english": "GDP"},
                "field": "GDP per capita in US",
                "valueTextTemplate": {"english": "The average GDP per capita in {{city}} is €{{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: €{{avg}}"}
            }, {
                "name": "greenArea",
                "active": false,
                "thumbnail": "icons/icon-greenspace.jpg",
                "label": {"english": "Green Space"},
                "field": "Green area m2 / million persons",
                "valueTextTemplate": {"english": "There is {{value}} square metres of green space in {{city}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }, {
                "name": "mealPrice",
                "active": false,
                "thumbnail": "icons/icon-affordable_dinner.jpg",
                "label": {"english": "Affordable Dinners Out"},
                "field": "Meal in affordable Restaurant (Price in €)",
                "valueTextTemplate": {"english": "The average meal out in {{city}} is €{{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: €{{avg}}"}
            }, {
                "name": "universityRank",
                "active": false,
                "thumbnail": "icons/icon-university.jpg",
                "label": {"english": "Top-Ranked Universities"},
                "field": "University Rank",
                "valueTextTemplate": {"english": "The top ranked university in {{city}} is ranked #{{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: #{{avg}}"}
            }, {
                "name": "ozone",
                "active": false,
                "thumbnail": "icons/icon-low_ozone.jpg",
                "label": {"english": "Low Ozone Emissions"},
                "field": "Days when ozone concentration exceeded 120 µg/m3",
                "valueTextTemplate": {"english": "The number of days when ozone concentration exceeded 120 µg/m3 in {{city}} is {{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }, /*{
                "name": "coolWeather",
                "active": false,
                "thumbnail": "icons/icon-coolerweather.jpg",
                "label": {"english": "Cooler Weather"},
                "field": "Average temperature",
                "valueTextTemplate": {"english": "The average temperature in {{city}} is {{value}}°C."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}°C"}
            },*/ {
                "name": "warmWeather",
                "active": false,
                "thumbnail": "icons/icon-warmerweather.jpg",
                "label": {"english": "Warmer Weather"},
                "field": "Average temperature",
                "valueTextTemplate": {"english": "The average temperature in {{city}} is {{value}}°C."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}°C"}
            }, {
                "name": "transportPrice",
                "active": false,
                "thumbnail": "icons/icon-affordable_transport.jpg",
                "label": {"english": "Affordable Transportation"},
                "field": "Transport (one way ticket)",
                "valueTextTemplate": {"english": "The average cost for a one way transportation ticket in {{city}} is €{{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: €{{avg}}"}
            }, {
                "name": "largePopulation",
                "active": false,
                "thumbnail": "icons/icon-large_population.jpg",
                "label": {"english": "Larger Population"},
                "field": "Population",
                "valueTextTemplate": {"english": "The population in {{city}} is {{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }, {
                "name": "smallPopulation",
                "active": false,
                "thumbnail": "icons/icon-lower_population.jpg",
                "label": {"english": "Smaller Population"},
                "field": "Population",
                "valueTextTemplate": {"english": "The population in {{city}} is {{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }, {
                "name": "families",
                "active": false,
                "thumbnail": "icons/icon-lots_of_families.jpg",
                "label": {"english": "Lots of Families"},
                "field": "Proportion of population aged 0-4 years",
                "valueTextTemplate": {"english": "{{value}}% of the population of {{city}} is age 0-4 years."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}%"}
            },/* {
                "name": "highProperty",
                "active": false,
                "thumbnail": "icons/icon-city_center_expensive.jpg",
                "label": {"english": "High Price City Center Per M2"},
                "field": "Price per m2 in city center (120 sq.m.)",
                "valueTextTemplate": {"english": "The price per m2 near the center of {{city}} is ${{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: ${{avg}}"}
            },*/ {
                "name": "lowProperty",
                "active": false,
                "thumbnail": "icons/icon-city_center_cheap.jpg",
                "label": {"english": "Low Price City Center Per M2"},
                "field": "Price per m2 in city center (120 sq.m.)",
                "valueTextTemplate": {"english": "The price per m2 near the center of {{city}} is €{{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: €{{avg}}"}
            }, {
                "name": "highDensity",
                "active": false,
                "thumbnail": "icons/icon-population_density_high.jpg",
                "label": {"english": "High Population Density"},
                "field": "Population density (persons per km2)",
                "valueTextTemplate": {"english": "There are {{value}} persons per km2 in {{city}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }, {
                "name": "lowDensity",
                "active": false,
                "thumbnail": "icons/icon-population_density_low.jpg",
                "label": {"english": "Low Population Density"},
                "field": "Population density (persons per km2)",
                "valueTextTemplate": {"english": "There are {{value}} persons per km2 in {{city}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }, {
                "name": "unemployment",
                "active": false,
                "thumbnail": "icons/icon-low_unemployment.jpg",
                "label": {"english": "Low Unemployment"},
                "field": "\"Unemployment rate in %\"*100",
                "valueTextTemplate": {"english": "The unemployment rate in {{city}} is {{value}}%."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}%"}
            }, {
                "name": "crime",
                "active": false,
                "thumbnail": "icons/icon-low_murder_rate.jpg",
                "label": {"english": "Low Homicide Rate"},
                "field": "Crime figure - Homicide rates (Rate per 100,000 people)",
                "valueTextTemplate": {"english": "The homicide rate per 100,000 people in {{city}} is {{value}}."},
                "avgTextTemplate": {"english": "EURO AVG: {{avg}}"}
            }
        ];

		this.getOptions = function() {
			return options;
		};
		this.getActiveOptions = function() {
			return options.filter(function(obj) {return obj.active === true});
		};
		this.changeOptionState = function(name, state) {
			options.find(function(obj) {return obj.name === name}).active = state;
		};
		this.resetOptions = function() {
			angular.forEach(options, function(option) {
				option.active = false;
			});
		};


		//var app = qlik.openApp('Euronews - Best City for You.qvf', config);
		var app = qlik.openApp('d9a2cadf-db52-4679-836a-969f51ff0d43', config);
		
		var expressionDictionary = {
			"museums": "Avg([Museums.normalized])",
			"gdp": "Avg([GDP.normalized])",
			"greenArea": "Avg([GreenArea.normalized])",
			"mealPrice": "(1 - Avg([MealPrice.normalized]))",
			"universityRank": "(1 - Avg([UniversityRank.normalized]))",
			"ozone": "(1 - Avg([Ozone.normalized]))",
			"coolWeather": "(1 - Avg([Temperature.normalized]))",
			"warmWeather": "Avg([Temperature.normalized])",
			"transportPrice": "(1 - Avg([TransportPrice.normalized]))",
			"largePopulation": "Avg([Population.normalized])",
			"smallPopulation": "(1 - Avg([Population.normalized]))",
			"families": "Avg([Proportion0-4.normalized])",
			"highProperty": "Avg([PropertyPrice.normalized])",
			"lowProperty": "(1 - Avg([PropertyPrice.normalized]))",
			"highDensity": "Avg([PopulationDensity.normalized])",
			"lowDensity": "(1 - Avg([PopulationDensity.normalized]))",
			"unemployment": "(1 - Avg([Unemployment.normalized]))",
			"crime": "(1 - Avg([Crime.normalized]))"
		};

		/**
		* Takes array of selections and returns results
		* @param {Array} of selections
		* @returns {Promise} that resolves when results are returned
		*/
		this.getResults = function(options) {
			var selections = options.map(function(obj) {return obj.name});
			var expression = "";
			angular.forEach(selections, function(selection) {
				expression += expressionDictionary[selection] + "+";
			});
			//remove final '+'
			expression = expression.slice(0, -1);

			var deferred = $q.defer();
			app.createCube({
				'qDimensions': [{
					'qDef': {
						qFieldDefs: ['[Metropolitan areas]']
					}
				}],
				'qMeasures': [{
					'qDef': {
						'qDef': expression
					},
					'qSortBy': {
		              'qSortByNumeric': -1,
		            }
				}],
				'qInterColumnSortOrder': [1,0],
                'qSuppressZero': true,
                'qSuppressMissing': true,
				'qInitialDataFetch': [{
					'qHeight': 10,
					'qWidth': 2
				}]
			}, function(reply) {
				app.destroySessionObject(reply.qInfo.qId);
				deferred.resolve(reply);
			});
			return deferred.promise;
		};

		/**
		* Takes option object and result city and returns KPI data points for option object
		* @param {Object} option
		* @param {String} city
		* @returns {Promise} that resolves when results are returned
		*/
		this.getOptionData = function(option, city) {
			var deferred = $q.defer();
			app.createGenericObject({
				val: {
					qStringExpression: '=Avg( {<[Metropolitan areas]={' + city + '}>} [' + option.field + '])'
				},
				avg: {
					qStringExpression: '=Avg([' + option.field + '])'
				}
			}, function(reply) {
				app.destroySessionObject(reply.qInfo.qId);
				deferred.resolve(reply);
			});
			return deferred.promise;
		};

		/**
		* Takes result city and returns data for results table
		* @param {String} city
		* @returns {Promise} that resolves when results are returned
		*/
		this.getTableData = function(city) {
			var deferred = $q.defer();
			app.createCube({
				'qDimensions': [{
					'qDef': {
						qFieldDefs: ['Characteristics']
					}
				}],
				'qMeasures': [{
					'qDef': {
						'qDef': 'Avg([' + city + '])'
					}
				}, {
					'qDef': {
						'qDef': 'Avg([Euro Avg])'
					}
				}],
                'qSuppressZero': true,
                'qSuppressMissing': true,
				'qInitialDataFetch': [{
					'qHeight': 50,
					'qWidth': 3
				}]
			}, function(reply) {
				app.destroySessionObject(reply.qInfo.qId);
				deferred.resolve(reply);
			});
			return deferred.promise;
		};
		
	};
    services.dataService.$inject = ['$http', '$q'];

    return services;
});
